<template>
    <div>
        <ts-card>
            <div class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative">
                <h4 class="ts-text-sm"></h4>
                <ts-modal-close-button />
            </div>
            <br />

            <ts-card-wrapper>
                <ts-loading-banner>
                    <form class="form-horizontal">
                        <fieldset>
                            <legend class="text-blue">Upload Photo</legend>
                            <div class="row mt-3">
                                <div class="col-md-12">
                                    <div class="ts-w-full ts-border-2 ts-border-dashed ts-rounded-md ts-p-4">
                                        <div id="img-frame" class="text-center">
                                            <label for="logo_file" id="label_logo_file">
                                                <img :src="logo_file_src" alt="" />
                                            </label>
                                            <input type="file" id="logo_file" ref="logo_file" accept="image/*"
                                                @change="onFileSelected" />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </fieldset>
                    </form>
                    <div class="ts-text-right mt-3">
                        <ts-button @click.prevent="$emit('close')">
                            {{ $t('cancel') }}
                        </ts-button>
                        <ts-button class="btn btn-primary ml-2" :waiting="waiting_save" @click.prevent="onSubmit">{{
                            $t('save') }}</ts-button>
                    </div>
                </ts-loading-banner>
            </ts-card-wrapper>
        </ts-card>
    </div>
</template>
<script>
import Fileview from './file-view.vue'
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex';

export default {
    name: 'attachedFile',
    components: {
        Fileview
    },
    data: function () {
        return {
            loading: false,
            waiting_save: false,
            fileChange: false,
            logo_file_src:
                'http://www.cgmsurgelati.it/wp-content/uploads/2017/09/loading.png',
            model: {
                attached_agreement: '',
                id: null,
            }
        }
    },
    computed: {
        ...mapState('crediTransfer', ['edit_data']),

    },
    created() {
        this.setEditData()
    },
    methods: {
        onFileSelected() {
            const file = this.$refs.logo_file.files[0]
            let reader = new FileReader()
            reader.addEventListener(
                'load',
                function () {
                    this.logo_file_src = reader.result
                }.bind(this),
                false
            )
            if (file) {
                if (/\.(jpe?g|png|gif)$/i.test(file.name)) {
                    reader.readAsDataURL(file)
                } else {
                    this.logo_file_src =
                        'http://www.cgmsurgelati.it/wp-content/uploads/2017/09/loading.png'

                    this.$toasted.error('invalid file type!')
                    this.$refs.logo_file.value = ''
                }
            }
        },
        uploadfile() {
            this.file = this.$refs.logo_file.files[0]
                ? this.$refs.logo_file.files[0]
                : null
            if (this.file) {
                let formData = new FormData()
                formData.append('logo', this.file)
                return this.$store.dispatch('crediTransfer/uploadLogo', formData)
            }

            return ''
        },

        async onSubmit() {
            this.errors = new Errors()
            this.waiting_save = true
            let file_upload_path = await this.uploadfile()

            this.$store
                .dispatch(
                    'crediTransfer/attachFile',
                    Object.assign({}, this.model, { attached_agreement: file_upload_path })
                )
                .then(response => {
                    this.waiting_save = false
                    this.$toasted.success(response.message)
                    this.$emit('fetchData')
                    this.$emit('close')
                })
                .catch(error => {
                    this.waiting_save = false
                    this.errors = new Errors(error.errors)
                    this.$toasted.error(error.message)
                })
        },
        // async onSubmit() {
        //     this.waiting_save = true
        //     this.errors = new Errors()
        //     let formData = new FormData()
        //     formData.append('id', this.model.id)
        //     const attachedAgreementsString = this.model.attached_agreement
        //         .map(file => file.name)
        //         .join(',');
        //     formData.append('attached_agreement', attachedAgreementsString)

        //     this.$store
        //         .dispatch('crediTransfer/attachFile', formData)
        //         .then(response => {
        //             this.waiting_save = false
        //             this.$toasted.success(response.message)
        //             this.$emit('fetchData')
        //             this.$emit('close')
        //         })
        //         .catch(error => {
        //             this.errors = new Errors(error.errors)
        //             this.$toasted.error(error.message)
        //         })
        //         .finally(() => {
        //             this.waiting_save = false
        //         })

        //     // on success clear value
        //     this.$refs.fileInput.value = ''
        // },

        setEditData() {
            this.model.id = this.edit_data.id
        }
    }
}
</script>

<style scoped>
#logo_file {
    display: none;
}

#img-frame img {
    object-fit: contain;
    width: 208px;
    height: 201px;
    /* box-shadow: 0 4px 6px rgba(0, 0, 0, .1); */
    border-radius: 10px;
    padding: 5px;
}

#label_logo_file {
    cursor: pointer;
}
</style>